import ValidatorsMessages from '@ember-intl/cp-validations/validators/messages';

import { translate } from 'umg-ember-backend/utils/intl';

export default ValidatorsMessages.extend({
  getDescriptionFor(attribute, options = {}) {
    let lookups = [
      `forms.${options.recordType}.fields.${attribute}`,
      `forms.defaults.fields.${attribute}`,
      'errors.description',
    ];

    if (options.descriptionKey) {
      lookups.unshift(options.descriptionKey);
    }

    return translate.call(this, options.description, lookups);
  },
});
